<template>
    <b-container>
        <div class="mt-3">            
            <b-card title="Card Title" no-body >
                <b-card-header header-tag="nav" class="no-print">                
                    <b-nav card-header tabs left sticky>       
                        <el-date-picker
                            v-model="dayData"
                            type="date"
                            placeholder="Pick a day"
                            :picker-options="pickerOptions">
                        </el-date-picker>

                        <el-date-picker
                            v-model="weekData"
                            type="week"
                            placeholder="Pick a week"
                            :picker-options="pickerOptions">
                        </el-date-picker>

                        <el-date-picker
                            v-model="monthData"
                            type="month"
                            placeholder="Pick a month"
                            :picker-options="pickerOptions">
                        </el-date-picker>

                        <el-date-picker
                            v-model="rangeData"
                            type="daterange"
                            range-separator="-"
                            start-placeholder="Start date"
                            end-placeholder="End date"
                            :picker-options="pickerOptions">
                        </el-date-picker>         

                        <b-nav-form class="ml-auto" right>
                            <b-nav-item @click="exportToExcel()">
                                <b-icon icon="file-earmark-spreadsheet" />
                            </b-nav-item>                                            
                            <b-nav-item @click="exportToPDF()">
                                <b-icon icon="file-earmark-text" />   
                            </b-nav-item>
                            <b-nav-item @click="printWindow()">
                                <b-icon icon="printer"  />
                            </b-nav-item>
                        </b-nav-form>       
                    </b-nav>                   
                </b-card-header>

                <b-card-body class="text-center p-0" >
                    <report-sales-summary v-if="report == 'Sales Summary'" :reqData="reqData"/>
                    <report-sales  v-if="report == 'Sales'" :reqData="reqData" />
                    <report-items  v-if="report == 'Items'" :reqData="reqData" />                    
                    <report-lost-sales  v-if="report == 'Lost Sales'" :reqData="reqData" />
                    <report-order-efficiency  v-if="report == 'Order Efficiency'" :reqData="reqData" />                    
                </b-card-body>
            </b-card>
        </div>                            
    </b-container>
</template>

<script>
// https://github.com/mengxiong10/vue2-datepicker
// import DatePicker from 'vue2-datepicker';
import ReportSalesSummary from '@/components/portal/ReportSalesSummary';
import ReportSales from '@/components/portal/ReportSales';
import ReportItems from '@/components/portal/ReportItems';
import ReportLostSales from '@/components/portal/ReportLostSales';
import ReportOrderEfficiency from '@/components/portal/ReportOrderEfficiency'

import htmlToPdfmake from "html-to-pdfmake"
var pdfMake = require('pdfmake/build/pdfmake.js');
var pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;
//https://stackoverflow.com/questions/52609607/vue-tables-2-create-pdf-file-from-multiple-selected-table-rows-using-pdfmake-lib

import { mapState } from 'vuex'

export default {
    components: { ReportSalesSummary, ReportSales, ReportItems, ReportLostSales, ReportOrderEfficiency},
    props:{
    },
    data(){
        const me = this;
        return {
            report:"Sales Summary",
            
            dayData:null,
            weekData:null,
            monthData:null,
            rangeData:null,                                
            base64: function(s){ return window.btoa(unescape(encodeURIComponent(s))) },
            format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) },
            lang: {
                formatLocale: {
                    firstDayOfWeek: 1,
                }
            },
            reqData : {start:null, end:null, filter:"Daily", msg:"", location:null},
            pickerOptions:{
                disabledDate(date) {
                    date = me.moment(date).toDate();
					return date > me.moment().toDate();
                },
                onPick({minDate, maxDate}){
                    console.log("SelectDate", minDate, maxDate)
                }
            }
        }
    },
    watch:{
        '$route.params.report': {
            handler: function(report) {
                this.report = report
            },
            deep: true,
            immediate: true
        },
        selectedLocation(){
            this.updateReqData()         
        },
        dayData(){
            this.reqData.filter = "Daily"
            this.reqData.start =  this.moment(this.dayData)
            this.reqData.end = this.moment(this.dayData)             
            this.updateReqData()   
        },
        weekData(){
             this.reqData.filter = "Weekly"
            this.reqData.start = this.moment(this.weekData).startOf('week')
            this.reqData.end = this.moment(this.weekData).endOf('week')                        
            this.updateReqData()               
        },
        monthData(){
            this.reqData.filter = "Monthly"
            this.reqData.start = this.moment(this.monthData).startOf('month')
            this.reqData.end = this.moment(this.monthData).endOf('month')
            this.updateReqData()               
        },
        rangeData(){
            this.reqData.filter = "DateRange"
            this.reqData.start = this.moment(this.rangeData[0])
            this.reqData.end = this.moment(this.rangeData[1])
            this.updateReqData()   
        },        
    },
    computed: { 
		...mapState({
            store: 'store',
            selectedLocation:'selectedLocation'
		}),		
    },
    methods:{
        updateReqData(){
                if(this.reqData.filter === null || this.reqData.start === null || this.reqData.end === null){
                    return
                }

                this.reqData.location = this.selectedLocation

                let stFormated = this.reqData.start.format("MMMM DD,YYYY")
                let etFormated = this.reqData.end.format("MMMM DD,YYYY")

                switch(this.reqData.filter){
                    case "Daily":
                        this.reqData.msg = `Report for ${stFormated}` 
                    break;
                    case "Weekly":
                         this.reqData.msg = `Report for the Week of ${stFormated}`  
                    break;
                    case "Monthly":
                         this.reqData.msg = `Report for the Month of ${stFormated}`  
                    break;
                    case "DateRange":
                         this.reqData.msg =  `Report for period: ${stFormated} thru ${etFormated}` 
                    break;                                                            
                }
        },
        async exportToExcel(){   
        // https://edwardize.blogspot.com/2019/07/vuejs-export-html-to-excel.html         
        // https://stackoverflow.com/questions/29698796/how-to-convert-html-table-to-excel-with-multiple-sheet
            
            let table = document.getElementById('reportContainer')
            let uri = 'data:application/vnd.ms-excel;base64,'
            var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
            let template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'

            let fileLink = document.createElement('a');
            fileLink.href = uri + this.base64(this.format(template, ctx));
            fileLink.download = this.reqData.msg;
            fileLink.click();            
        
        },
        downloadCSV() {
            var csv = [];
            var rows = document.querySelectorAll("table tr");    
            for (var i = 0; i < rows.length; i++) {
                var row = [], cols = rows[i].querySelectorAll("td, th");    
                for (var j = 0; j < cols.length; j++) 
                    row.push(cols[j].innerText);        
                csv.push(row.join(","));        
            }
            var csvFile;
            var downloadLink;
            // CSV file
            csvFile = new Blob([csv.join("\n")], {type: "text/csv"});
            // Download link
            downloadLink = document.createElement("a");
            // File name
            downloadLink.download = this.reqData.msg + ".csv";
            // Create a link to the file
            downloadLink.href = window.URL.createObjectURL(csvFile);
            // Hide download link
            downloadLink.style.display = "none";
            // Add the link to DOM
            document.body.appendChild(downloadLink);
            // Click download link
            downloadLink.click();
        },
        async exportToPDF() {
            var val = htmlToPdfmake(document.getElementById('reportContainer').outerHTML, {
                tableAutoSize:true
            });
            var dd = {
                       content:val, 
                       info: {
                            title: this.reqData.msg,
                            author: 'Claren Menu',
                            subject: this.reqData.msg,
                            keywords: 'Report'
                        }
                    };            
            pdfMake.createPdf(dd).download(this.reqData.msg);
        },
        printWindow() {		
            window.print();
        },
        outOfRangeDate(date){                        
            return date > this.moment().subtract(1, 'days').toDate();
        },                           
    },
    created(){
        this.reqData.filter = "Daily"
        this.reqData.start = this.moment()
        this.reqData.end =  this.moment()   
        this.updateReqData()
    },    
}
</script>
<style scoped>
.mydropdown /deep/ .dropdown-menu-right{
    right: unset;
    left: unset; 
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 330px;
}
.mydropdown /deep/ .dropdown-item{
    overflow-x: hidden;
}
</style>